import styled from 'styled-components';

export const TitleLabel = styled.label`
  color: var(--grey);
  padding: 10px 0 0 7px;
`;
